import { deviceManager } from '@hid/device/device_manager'

export const handleImageLightFrame = async (data: number[]): Promise<boolean> => {
  if (!Array.isArray(data) || data.length === 0) {
    return false
  }

  return await deviceManager.deviceDriver.syncImageLightFrame(data)
}
